export default __webpack_public_path__ + "static/MineralSwimV2_BENEFITS_Generator&Purifier_1920x1000-f79ed1a415ac86f56c28ba22bf673f84.jpg";